import type { ComponentInstance } from '../component.js';
import { setText } from '../dom-helpers.js';

export interface PerfHudProps {
  visible: boolean;
  fps: number;
  embed: boolean;
}

export function mountPerfHud(
  root: HTMLElement,
  initial: PerfHudProps,
): ComponentInstance<PerfHudProps> {
  const panel = document.createElement('div');
  panel.classList.add('viewer-ui-interactive');
  panel.setAttribute('role', 'status');
  panel.setAttribute('aria-live', 'off');
  panel.style.cssText =
    'position:fixed;bottom:0.75rem;right:0.75rem;background:rgba(15,15,17,0.85);backdrop-filter:blur(8px);color:#f4f4f5;padding:0.375rem 0.625rem;border-radius:0.375rem;font-family:ui-monospace,SFMono-Regular,Menlo,monospace;font-size:0.75rem;z-index:11;pointer-events:none';

  const label = document.createElement('span');
  panel.appendChild(label);
  root.appendChild(panel);

  const update = (props: PerfHudProps): void => {
    panel.style.display = props.visible ? 'block' : 'none';
    setText(label, `${Math.round(props.fps)} FPS`);
  };
  update(initial);

  return {
    update,
    cleanup() {
      panel.remove();
    },
  };
}
